import moment from 'moment';
import React, { useEffect, useRef } from 'react';

const formatHullNumber = (hullNumber) => {
    const normalizedHull = String(hullNumber || '').trim().replace(/^HN[\s-]*/i, '');
    return normalizedHull ? `HN ${normalizedHull}` : 'HN';
};

const PastEvents = ({ data, filter, setFilter, page, setPage, limit, total }) => {

    const scrollableDivRef = useRef(null);
    const isFetchingRef = useRef(false);

    // 🔥 Calculate totalPages and if more data exists
    const totalPages = Math.ceil(total / limit);
    const hasMoreData = page < totalPages;

    useEffect(() => {
        const handleScroll = () => {
            const container = scrollableDivRef.current;
            if (container) {
                const { scrollTop, scrollHeight, clientHeight } = container;
                if (scrollHeight - scrollTop - clientHeight < 50) {
                    if (hasMoreData && !isFetchingRef.current) {
                        isFetchingRef.current = true;
                        // alert('Reached near bottom!');

                        setPage(prev => prev + 1);
                    }
                }
            }
        };

        const container = scrollableDivRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, [page, limit, total, hasMoreData, setPage]);

    useEffect(() => {
        isFetchingRef.current = false;
    }, [data]);

    return (
        <div className="row">
            {/* {!hasMoreData && (
                <div className="text-center text-muted py-2">No more past events.</div>
            )} */}
            <div className="col-lg-12">
                <div className="card-body card-body-z">
                    <div className="mb-5 card-title">
                        Past Events
                        <div className="d-flex justify-content-start gap-1 mb-3 mt-2 flex-wrap">
                            {['60 Days', '120 Days', 'Last Year', 'All'].map((label) => (
                                <button
                                    key={label}
                                    onClick={() => {
                                        setFilter(label);
                                        setPage(1);
                                    }}
                                    className="btn"
                                    style={{
                                        border: '1px solid #ccc',
                                        backgroundColor: filter === label ? '#ddd' : '#f9f9f9',
                                        color: filter === label ? '#000' : '#007bff',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        padding: '4px 10px',
                                        fontWeight: filter === label ? '500' : '400',
                                    }}
                                >
                                    {label === '60 Days' ? 'Last 60 days' :
                                        label === '120 Days' ? 'Last 120 days' :
                                            label === 'Last Year' ? 'Last year' :
                                                'All'}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div
                        ref={scrollableDivRef}
                        style={{
                            maxHeight: '500px',
                            overflowY: 'auto',
                            // paddingRight: '10px',
                            // border: '1px solid #eee',
                            // borderRadius: '8px'
                        }}
                    >
                        <ul className="verti-timeline list-unstyled">
                            {data?.length > 0 ? data.map((event, index) => (
                                <li key={index} className="event-list">
                                    <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle" />
                                    </div>
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <div>
                                                {moment(event.CREATED_ON).format('MMM DD, YYYY')}
                                                <h5 className="font-size-14 mb-1" style={{ color: event.COLOR_CODE || 'black' }}>
                                                    {event.EVENT_TYPE}&nbsp;<i className='mdi mdi-arrow-right text-primary' />&nbsp;
                                                    <span style={{ color: "#8c8c8c" }}>{event.CATEGORY_NAME}</span>
                                                </h5>
                                                <p className="text-muted mb-0 font-size-13">
                                                    <span style={{ color: "#ab5858" }}>
                                                        {formatHullNumber(event.HULL_NUMBER)} - {event.SHIP_NAME}, {event.PROJECT_CODE} - {event.PROJECT_NAME}
                                                    </span>
                                                </p>
                                                <a href="javascript:void(0);" className="text-dark">
                                                    <span style={{ color: "#676767" }}>
                                                        <span style={{ fontSize: '14px' }}>{event.CREATED_BY_NAME}</span> {event.NEW_STATUS} <span style={{ fontSize: '14px' }}>{event.EVENT_TYPE}</span> {event.NEW_STATUS !== 'Updated' && 'Event'}
                                                        {event.NEW_STATUS === 'Updated' && (
                                                            <>
                                                                {event.OLD_START_DATE && event.START_DATE && (
                                                                    <> - Event Start Date changed from <em>{event.OLD_START_DATE}</em> to <em>{event.START_DATE}</em></>
                                                                )}
                                                                {event.OLD_END_DATE && event.END_DATE && (
                                                                    <> | End Date changed from <em>{event.OLD_END_DATE}</em> to <em>{event.END_DATE}</em></>
                                                                )}
                                                            </>
                                                        )}
                                                        {event.REMARK && (
                                                            <> | Remark changed to <em>{event.REMARK}</em></>
                                                        )}
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )) : (
                                <div className="text-center text-muted">No timeline found.</div>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PastEvents;
